/*
 * Created by: cparaschiv
 * Date: 19.06.2014, 14:04 
 */

(function($) {
    'use strict';

    var ui = kendo.ui,
        TreeView = ui.TreeView,
        CHANGE = "change",
        CLICK = 'click',
        NS = '.tsKendoTree',
        unwrap = TS.unwrap;

    function _buildCommandUI(cmd, tlpName){
        var code = unwrap(cmd.Code),
            text = unwrap(cmd.Text),
            tpl, html,
            id = tlpName + '.' + code;

        tpl = ['<a class="ts-tree-command" id="' + id + '" name="' + id + '" type="hyperlink" data-bind="cmd: \'' + id + '\'">' + text,
                '</a>'];

        html = tpl.join('');

        return html;
    }

    var TsKendoTree = TreeView.extend({

        _treeListProperty: null,
        _checkedProperty: 'checked',

        options: {
             name: "TsKendoTree"
        },

        init: function(element, options) {
            var me = this,
                tlp;

            tlp = options.treeList;
            me._treeListProperty = options.treeList;
            if (TS.isDefined(tlp.checkedPropertyName)) {
                me._checkedProperty = tlp.checkedPropertyName
            }

            options = $.extend({}, options, {
                dataTextField: tlp.textPropertyName
            });

            if (tlp.checkboxes) {
                options = $.extend({}, options, {
                    checkboxes: {
                        checkChildren: TS.ifNotDefined(tlp.checkChildren, true)
                    }
                });
            }

            TreeView.fn.init.call(this, element, options);

            if (TS.isDefined(tlp.height) && TS.isNumber(tlp.height)) {
                me.wrapper.attr('style', 'height: ' + tlp.height + 'px');
            }
            if (TS.isNumber(tlp.autoExpandLevel)) {
                //
            }

            tlp.on('expandAll', function() {
                me.expand('.k-item');
            });
            tlp.on('collapseAll', function() {
                me.collapse('.k-item');
            });

            tlp.on('dataSourceChanged', function(e) {
                me.setDataSource(e.dataSource);
                //me._syncHtmlAndDataSource();
            });
        },

        _buildToolbar: function(commands, blpName) {
            var html = '';

            $.each(commands, function(i, cmd) {
                var cmdHtml;

                cmdHtml = _buildCommandUI(cmd, blpName);
                if (cmdHtml) {
                    html += cmdHtml;
                }
            });

            return html;
        },

        _wrapper: function() {
            var me = this,
                wrapper, content,
                toolbar, toolbarContent,
                tlp = me._treeListProperty;

            TreeView.fn._wrapper.call(me);

            wrapper = me.wrapper;
            content = wrapper.append('<div class="k-tree-content"></div>').children(0);

            toolbarContent = me._buildToolbar(tlp.commands, tlp.name);
            toolbar = $('<div class="k-toolbar k-tree-toolbar">')
                        .html(toolbarContent)
                        .prependTo(wrapper);

            me.wrapper = content;
            me.toolbar = toolbar;
            me.container = wrapper;
        },

        _setChecked: function(datasource, value) {
            var me = this,
                i = 0, nodes, len;
            if (!datasource || !$.isFunction(datasource.view)) {
                return;
            }

            for (i = 0, nodes = datasource.view(), len = nodes.length; i < len; i++) {
                nodes[i][me._checkedProperty] = value;

                if (nodes[i].children) {
                    me._setChecked(nodes[i].children, value);
                }
            }
        },

        _progress: function(node, showProgress) {
            var me = this,
                tmp = me.element;

            me.element = me.wrapper;

            TreeView.fn._progress.apply(me, arguments);

            me.element = tmp;
        },

        //_templates: function() {
        //    var me = this,
        //        tpl;
        //
        //    TreeView.fn._templates.apply(me);
        //},
        //
        refresh: function(e) {
            var me = this;
            TreeView.fn.refresh.call(me, e);
        }

    });

    ui.plugin(TsKendoTree);

    ko.bindingHandlers['kendoTsTree'] = {
        init: function (element, valueAccessor, allBindings, viewModel, bindingContext) {
            var config = valueAccessor(),
                tlp, ds,
                $element,
                id;

            tlp = TS.Util.getProperty(bindingContext.$data, config.dataSource);
            $element = $(element);

            if(!tlp){
                TS.Log.error("Error: Invalid data source " + config.dataSource + " for tree " + $element.attr('id'));
                return;
            }

            //ds = new TS.data.KoTreeSource({
            //    data: tlp.records,
            //    schema: {
            //        model: {
            //            uid: tlp.identifier,
            //            children: tlp.childPropertyName,
            //            hasChildren: 'hasChildren'
            //
            //        }
            //    },
            //    checkedPropertyName: tlp.checkedPropertyName
            //});

            ds = tlp.buildTreeSource(tlp.records);
            tlp.setTreeSource(ds);


            TS.trace('kendoTreeView');
            $element.kendoTsKendoTree({
                dataSource: ds,
                treeList: tlp
            });
        }
    };

})(jQuery);
